

















































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import CurrentHoldingsChart from "@/shared/components/investments/drivewealth/CurrentHoldingsChart.vue";
import InvestmentInstrumentPieChart from "@/shared/components/charts/InvestmentInstrumentPieChart.vue";
import InvestmentGenericLineGraph from "@/shared/components/charts/InvestmentGenericLineGraph.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import InvestWithDrivewealthWidget from "@/employee/components/investments/drivewealth/InvestWithDrivewealthWidget.vue";
import PreenrollmentWidget from "@/employee/components/investments/drivewealth/PreenrollmentWidget.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import UserPartnerContent from "@/employee/components/investments/drivewealth/UserPartnerContent.vue";
import PreenrollmentManagement from "@/shared/components/investments/drivewealth/PreenrollmentManagement.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import HsabInvestmentAccountRedirectLink from "@/shared/components/investments/HsabInvestmentAccountRedirectLink.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import {
  DrivewealthWizardStep,
  DrivewealthAccountManagementType,
  ChartPointDataType,
  DrivewealthAccountIdentifierArgs,
  DrivewealthAccountPerformance,
  DrivewealthAccountSummary
} from "@/shared/types";
import * as SharedRoutes from "@/shared/route-names";
import * as Routes from "@/employee/route-names";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";

@Component({
  components: {
    DrivewealthNavigation,
    CurrentHoldingsChart,
    InvestmentGenericLineGraph,
    InvestmentInstrumentPieChart,
    GenericLoadingSpinner,
    InvestWithDrivewealthWidget,
    RiskDisclaimer,
    UserPartnerContent,
    PreenrollmentWidget,
    PreenrollmentManagement,
    AccountTypeSubheader,
    HsabInvestmentAccountRedirectLink,
  },
  computed: {
    ChartPointDataType () {
      return ChartPointDataType;
    }
  }
})
export default class DrivewealthAccountSummaryView extends Vue {
  drivewealthStore = useDrivewealthStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();

  DrivewealthAccountManagementType = DrivewealthAccountManagementType;
  formatCurrency = formatCurrency;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  load (): void {
    this.drivewealthAccountPerformanceStore.setFromDateToFirstOfMonth();
    this.drivewealthAccountPerformanceStore.setSelectedAccountId(this.accountId);
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthSweepStore.getSweepV2({});
    this.drivewealthWizardStore.loadExistingPreenrollment({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthStore.loadAccountSummariesV2({});
    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers);
  }

  @Watch("accountId")
  reload (): void {
    this.load();
  }

  mounted (): void {
    this.load();
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  formatInvestmentReturnDisplayCopy (amount?: number): string {
    if (amount) {
      return this.formatCurrency(amount);
    }

    return "--";
  }

  get showLoadingSpinner (): boolean {
    return !this.isLoaded;
  }

  get accountPerformanceDataLoaded (): boolean {
    return this.drivewealthAccountPerformanceStore.accountPerformanceLoaded(this.accountIdentifiers);
  }

  get hasAccountPerformanceData (): boolean {
    return !this.accountPerformanceResult.emptyDataSetMessage;
  }

  get isLoaded (): boolean {
    return this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded &&
        this.drivewealthSweepStore.sweepLoaded &&
        this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get showPreenrollment (): boolean {
    return !this.investmentDailyBalanceStore.hasEnoughToOpenAccount &&
        this.drivewealthWizardStore.isAllowedToPreenroll;
  }

  get accountPerformanceResult (): DrivewealthAccountPerformance {
    return this.drivewealthAccountPerformanceStore.accountPerformanceResult(this.accountIdentifiers);
  }
}
